import { getUserDetails, makeGetCall, makePostCall } from './helper';

const STORAGE_KEY = 'ohif-favorite-tools-by-modality';

const getUsername = () => {
  const u = getUserDetails();
  return u?.username || u?.user_name || null;
};

const writeLocal = favorites => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(favorites));
  } catch (e) {
    console.warn('favoriteToolsApi: failed to write localStorage', e);
  }
};

// Hydrate localStorage from backend before FavoriteService reads it.
export const preloadFavoriteTools = async () => {
  const username = getUsername();
  if (!username) return null;

  try {
    const resp = await makeGetCall(
      `/get-user-preference?username=${encodeURIComponent(username)}&type=favorite_tools`
    );
    const favorites = resp?.data?.data;
    if (favorites) {
      writeLocal(favorites);
      return favorites;
    }
  } catch (e) {
    console.warn('favoriteToolsApi: preload failed, using local/default config', e);
  }
  return null;
};

// Persist to backend AND mirror into localStorage.
export const persistFavoriteTools = async favorites => {
  const username = getUsername();

  writeLocal(favorites);

  if (!username) return favorites;

  try {
    await makePostCall('/save-user-preference', { 
        username, 
        type: 'favorite_tools',
        value: favorites 
    });
  } catch (e) {
    console.error('favoriteToolsApi: failed to persist favorite tools', e);
    // Don't throw, we just best-effort sync.
  }
  return favorites;
};
